/*
 * SonarQube
 * Copyright (C) 2009-2025 SonarSource SA
 * mailto:info AT sonarsource DOT com
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with this program; if not, write to the Free Software Foundation,
 * Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import styled from '@emotion/styled';
import { OPACITY_20_PERCENT, themeBorder, themeColor, themeContrast } from '../../../helpers';
import { Button } from './Button';

/**
 * @deprecated Use Button from Echoes instead without the `variety` prop set,
 * this is the default look and feel of the button.
 *
 * Some of the props have changed or been renamed:
 * - `blurAfterClick` is now `enableBlurAfterClick`
 * - `disabled` is now `isDisabled`, note that a Echoes Tooltip won't work
 * on a disabled button, use a text notice or ToggleTip next to the disabled button instead.
 * - `icon` is now replace by `prefix` which works the same way
 * - `preventDefault` is now `enablePreventDefault`
 * - `stopPropagation` is now `enableStopPropagation`
 *
 */
export const ButtonSecondary = styled(Button)`
  --background: ${themeColor('buttonSecondary')};
  --backgroundHover: ${themeColor('buttonSecondaryHover')};
  --color: ${themeContrast('buttonSecondary')};
  --focus: ${themeColor('buttonSecondaryBorder', OPACITY_20_PERCENT)};
  --border: ${themeBorder('default', 'buttonSecondaryBorder')};
`;
